/** Host dispatches this after a menu navigation. Plugin routers do not see `pushState` as `popstate`. */
export const PHOENIX_PLUGIN_URL_CHANGED_EVENT = 'phoenix-plugin-url-changed';

/**
 * True when `pathname` is the plugin mount or a child of it.
 * `/customElements/test` must not match a sibling mount `/customElements/test-extra`.
 */
export function isBrowserPathUnderPluginBase(pathname: string, baseHref: string): boolean {
  if (baseHref === '/' || baseHref === '') {
    return true;
  }
  const normalizedBase = baseHref.endsWith('/') ? baseHref.slice(0, -1) : baseHref;
  return pathname === normalizedBase || pathname.startsWith(`${normalizedBase}/`);
}
